import { store_getStateValue_vo, store_setStateValue, store_var } from "@/store"

// cacheServer_save_f
export const cacheServer_save_f = (path_as, query_s, data_o) => {

    let current_cacheServerTree_o = getCurrentCacheServerTree_o()

    path_as.forEach((path, index) => {

        if(!current_cacheServerTree_o[path]){
            current_cacheServerTree_o[path] = {}
        }

        if(index === path_as.length-1){
            current_cacheServerTree_o[path][query_s] = data_o
            // current_cacheServerTree_o[path] = data_o

        }else{
            current_cacheServerTree_o = current_cacheServerTree_o[path]
        }
    })

    store_setStateValue(store_var.serverCacheTree, cacheServerTree_o)
}

// cacheServer_get_f
export const cacheServer_get_fo = (path_as, query_s) => {

    let current_cacheServerTree_o = getCurrentCacheServerTree_o()

    path_as.forEach((path, index) => {

        if(current_cacheServerTree_o[path] ){
            current_cacheServerTree_o = current_cacheServerTree_o[path]
        }
    })

    return current_cacheServerTree_o[query_s]
    // return current_cacheServerTree_o
}

// ======== local ============
let cacheServerTree_o;

// getCurrentCacheServerTree_o
const getCurrentCacheServerTree_o = () => {
    if(!cacheServerTree_o ){
        cacheServerTree_o = store_getStateValue_vo(store_var.serverCacheTree).val
    }
    return cacheServerTree_o
}
// queryAsString

